import UsuarioService from '@/src/services/usuario'

const produtoMixin = {
  data() {
    return {
      usuariosFields: [
        {
          key: 'nome',
          label: 'Nome',
          class: 'size-col-20',
          field: 'nome',
        },
        {
          key: 'email',
          label: 'E-mail',
          class: 'size-col-20',
        },
        { key: 'actions', label: '', class: 'size-col-10' },
      ],
    }
  },
  methods: {
    async registerUsuario(usuario) {
      return await UsuarioService.create(usuario)
    },
    loadUsuarios() {
      return UsuarioService.list()
        .then((response) => {
          return response
        })
        .catch((error) => error)
    },
    async editUsuario(id, usuario) {
      return await UsuarioService.update(id, usuario)
    },
    async deleteUsuario(id) {
      await UsuarioService.remove(id)
    },
  },
}

export default produtoMixin
